import { MONEDA } from "./config";

const formateadorMoneda = new Intl.NumberFormat("es-PE", {
  style: "currency",
  currency: MONEDA,
  minimumFractionDigits: 2,
});

/** S/ 1,234.50 — devuelve un guion si no hay precio cargado. */
export function soles(valor) {
  if (valor === null || valor === undefined || Number.isNaN(Number(valor))) return "—";
  return formateadorMoneda.format(Number(valor));
}

const formateadorNumero = new Intl.NumberFormat("es-PE", {
  maximumFractionDigits: 2,
});

export function numero(valor, sufijo = "") {
  if (valor === null || valor === undefined || Number.isNaN(Number(valor))) return "—";
  return formateadorNumero.format(Number(valor)) + (sufijo ? ` ${sufijo}` : "");
}

/** Acepta Timestamp de Firestore, Date o string ISO. */
export function fecha(valor, conHora = false) {
  if (!valor) return "—";
  const d = valor?.toDate?.() ?? (valor instanceof Date ? valor : new Date(valor));
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("es-PE", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    ...(conHora ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
}

/** "varilla-1-2-x-9m" a partir de un nombre. */
export function slug(texto = "") {
  return texto
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Mn}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Codigo legible para cotizaciones y pedidos: COT-260907-4821 */
export function generarCodigo(prefijo) {
  const d = new Date();
  const ymd = [
    String(d.getFullYear()).slice(2),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0"),
  ].join("");
  const aleatorio = String(Math.floor(Math.random() * 9000) + 1000);
  return `${prefijo}-${ymd}-${aleatorio}`;
}
